import getSimulatorQuestions from './getSimulatorQuestions';

export default getSimulatorQuestions;
